module.exports = __webpack_public_path__ + "components/country-flag/static/sm-9fe31931f07d44d21d2d086c28897ec0.svg";